import React, { useState } from 'react';
import axios from 'axios';
import { useLang } from '../context/LangContext';
import { API_URL } from '../config';

const ContactPage = () => {
  const { t } = useLang();
  const [form, setForm]           = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent]           = useState(false);
  const [errors, setErrors]       = useState({});
  const [sending, setSending]     = useState(false);
  const [sendError, setSendError] = useState('');

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = t('required');
    if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) e.email = t('invalid_email');
    if (!form.subject.trim()) e.subject = t('required');
    if (!form.message.trim()) e.message = t('required');
    return e;
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    if (errors[name]) setErrors(er => ({ ...er, [name]: undefined }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setSendError('');
    setSending(true);
    try {
      await axios.post(`${API_URL}/messages`, form);
      setSent(true);
    } catch (err) {
      setSendError(err.response ? t('checkout_generic_error') : t('checkout_network_error'));
    } finally {
      setSending(false);
    }
  };

  const contacts = [
    { icon: '📍', label: t('contact_address_label'), value: 'Tunis, Tunisie' },
    { icon: '📞', label: t('contact_phone_label'),   value: '+216 XX XXX XXX' },
    { icon: '✉️', label: t('contact_email_label'),   value: 'contact@matrix-electronic.tn' },
    { icon: '🕐', label: t('contact_hours_label'),   value: t('contact_hours_value') },
  ];

  return (
    <div className="contact-page">
      {/* Banner */}
      <div className="contact-banner">
        <h1>{t('contact_title')}</h1>
        <p>{t('contact_subtitle')}</p>
      </div>

      <div className="contact-page__inner">
        {/* Contact info */}
        <div className="contact-info">
          <h2>{t('get_in_touch')}</h2>
          <p className="contact-info__desc">{t('contact_info_desc')}</p>
          {contacts.map(c => (
            <div className="contact-info__item" key={c.label}>
              <span className="contact-info__icon">{c.icon}</span>
              <div>
                <strong>{c.label}</strong>
                <p>{c.value}</p>
              </div>
            </div>
          ))}
          <div className="contact-socials">
            {['Facebook', 'Instagram', 'WhatsApp'].map(s => (
              <button key={s} className="contact-social-btn">{s}</button>
            ))}
          </div>
        </div>

        {/* Form */}
        {sent ? (
          <div className="contact-success">
            <div className="contact-success__icon">✅</div>
            <h3>{t('message_sent_title')}</h3>
            <p>{t('message_sent_sub')}</p>
            <button className="btn btn--primary" onClick={() => { setSent(false); setForm({ name:'', email:'', subject:'', message:'' }); }}>
              {t('send_another')}
            </button>
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <h2>{t('send_message')}</h2>
            {[
              { label: t('your_name'),    name: 'name',    type: 'text'  },
              { label: t('your_email'),   name: 'email',   type: 'email' },
              { label: t('your_subject'), name: 'subject', type: 'text'  },
            ].map(f => (
              <div className="form-field" key={f.name}>
                <label>{f.label}</label>
                <input type={f.type} name={f.name} value={form[f.name]} onChange={handleChange} className={errors[f.name] ? 'input--error' : ''} />
                {errors[f.name] && <span className="field-error">{errors[f.name]}</span>}
              </div>
            ))}
            <div className="form-field">
              <label>{t('your_message')}</label>
              <textarea name="message" rows="5" value={form.message} onChange={handleChange} className={errors.message ? 'input--error' : ''} />
              {errors.message && <span className="field-error">{errors.message}</span>}
            </div>
            {sendError && (
              <div className="checkout-error" role="alert">⚠️ {sendError}</div>
            )}

            <button type="submit" className="btn btn--primary btn--full" style={{ padding: '14px' }} disabled={sending}>
              {sending ? '⏳' : t('send_message_btn')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactPage;
